import React, { useRef, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

const CommonModal = ({
    isOpen,
    onClose,
    title,
    subtitle,
    content,
    imageUrl,
    position
}) => {
    const modalRef = useRef(null);

    const [rootElement, setRootElement] = useState(null);

    // Find the root element when component mounts
    useEffect(() => {
        const root = document.getElementById('root');
        if (root) {
            setRootElement(root);
        }
    }, []);

    // Add/remove overflow hidden on body when modal opens/closes
    useEffect(() => {
        if (isOpen) {
            // Store original overflow value
            const originalOverflow = document.body.style.overflow;
            
            // Add overflow hidden to body
            document.body.style.overflow = 'hidden';
            
            // Clean up when modal closes
            return () => {
                document.body.style.overflow = originalOverflow;
            };
        }
    }, [isOpen]);

    // Close modal when clicking outside
    // useEffect(() => {
    //     const handleClickOutside = (event) => {
    //         if (modalRef.current && !modalRef.current.contains(event.target)) {
    //             onClose();
    //         }
    //     };

    //     if (isOpen) {
    //         document.addEventListener('mousedown', handleClickOutside);
    //     }
        
    //     return () => {
    //         document.removeEventListener('mousedown', handleClickOutside);
    //     };
    // }, [isOpen, onClose]);

    return isOpen ? (
        ReactDOM.createPortal(
            <div>
                <div className="fixed inset-0 bg-black bg-opacity-50 z-40 h-[100dvh] w-full top-0 left-0 opacity-100 transition-all duration-300 ease-in-out"></div>
                <div className="fixed inset-0 flex items-center justify-center z-50">
                    <div
                        ref={modalRef}
                        className="bg-white rounded-[12px] shadow-lg max-w-[1366px] xl-xxl:w-full w-[90%] relative"
                    >
                        <button
                            onClick={onClose}
                            className="absolute top-[20px] right-[20px] text-gray-500 hover:text-gray-700 text-2xl"
                            aria-label="Close"
                        >
                            <img src='/cross.svg' className='h-[20px] w-[20px]' alt="Close" />
                        </button>

                        <div className="md:flex gap-x-[35px] lg-xl:p-[50px] p-[30px]">
                            {imageUrl ? (
                                <div className="w-[39%] max-w-[39%] xs:mx-0 mx-auto">
                                    <img
                                        src={imageUrl}
                                        alt={title || "Modal image"}
                                        className="w-full"
                                    />
                                </div>
                            ) : (
                                <div className="w-[39%] max-w-[39%] xs:mx-0 mx-auto">
                                    <div className="bg-gray-200 rounded-[15px] h-64"></div>
                                </div>
                            )}

                            <div className="md:w-[60.5%] md:max-w-[60.5%] md:pt-0 pt-4">
                                {title && <h2 className="pb-[10px] xl:text-[34px] xl:leading-[44px] lg:text-[30px] lg:leading-[36px] text-[24px] leading-[32px] font-semibold font-fira">{title}</h2>}
                                {position && <h2 className="pb-[10px] xl:text-[30px] xl:leading-[40px] lg:text-[26px] lg:leading-[30px] text-[24px] text-lightBlack leading-[32px] font-semibold font-fira">{position}</h2>}
                                {subtitle && <p className="xs:pb-[20px] pb-[15px] xl:text-22px xl:leading-[35.2px] text-18px leading-[28px] font-fira font-normal">{subtitle}</p>}

                                <div className='overflow-auto lg:max-h-[525px] md:max-h-[400px] max-h-[300px]'>
                                    {typeof content === 'string' ? (
                                        <p className='xl:text-22px xl:leading-[35.2px] text-18px leading-[28px] font-fira font-normal pb-[10px]'>{content}</p>
                                    ) : Array.isArray(content) ? (
                                        content.map((paragraph, idx) => (
                                            <p className='xl:text-22px xl:leading-[35.2px] text-18px leading-[28px] font-fira font-normal pb-[10px]' key={idx}>{paragraph}</p>
                                        ))
                                    ) : (
                                        content
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
            document.body
        )
    ) : null;
};

export default CommonModal;